import router from './router'
import store from './store'
import { getEnv } from '@/utils/tool'

const parentAuthRouterList = [
  '/parents',
  '/parentBindStu',
  '/correct',
  // '/holiday/list',
  '/personResults',
  '/facePunchLogs',
  '/contactTeacher',
  '/teacherComments',
  '/classSchedule',
  '/dailyWorks',
  '/studentDetail',
  '/leaveManage',
  '/notice'
]
router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }
  if(getEnv() === 'h5') {
    const channel = to.query.channel
    if(channel) {
      localStorage.setItem('channel', channel)
    }
  }
  // 客户端没有存好数据 重新加载一次
  if(getEnv() === 'app' && !localStorage.getItem('load') && !localStorage.getItem('header_json')) {
    localStorage.setItem('load', 1)
    next(`/redirect?url=${encodeURIComponent(window.location.href)}`)
  }
  if(getEnv() !== 'app' && parentAuthRouterList.includes(to.path)) {
    const token = localStorage.getItem('token')
    if(token) {
      store.dispatch('GetUserInfo').then(res => {
        if(res.student_id || (to.path === '/parentBindStu')) {
          if(to.path === '/parents') {
            document.title = res.studio_name
          }
          next()
        } else {
          next('/parentBindStu')
        }
      }).catch(() => {
        localStorage.removeItem('token')
        next('/login')
      })
    } else {
      next('/login')
    }
  } else if(getEnv() === 'app' && parentAuthRouterList.includes(to.path)){
    let userid = ''
    if(to.path === '/studentDetail' && to.query.student_id) {
      userid = to.query.student_id
    } else {
      userid = JSON.parse(localStorage.getItem('header_json')).userid
    }
    store.dispatch('GetUserInfoInApp', userid).then(res => {
      next()
    })
  } else {
    next()
  }
})


// WEBPACK FOOTER //
// ./src/permission.js